// Single source of truth for the app's colour tokens. Both the MUI theme
// (theme.jsx) and the panel style helpers (panelStyles.js) derive from here,
// so a colour is defined exactly once.

// Brand
export const WW_ORANGE = "#f69e00"
export const WW_ORANGE_LIGHT = "#fed389"
export const WW_BLUE = "#004f7d"
export const WW_BLUE_DARK = "#013a5c"
export const WW_BLUE_MID = "#1d8ed4"
export const WW_BLUE_LIGHT = "#157dc7"
export const WHITE = "#ffffff"

// Warnings
export const WARN_SOFT = "#f0ee61"
export const WARN_STRONG = "#ff0000"

// Panel greys / accents (shared by the left-hand panels)
export const PANEL_TEXT_MUTED = "#57728d"
export const PANEL_TEXT_FAINT = "#8a98a6"
export const PANEL_CARD_BG = "#fafbfc"
export const PANEL_CARD_BORDER = "rgba(0, 79, 125, 0.10)"
export const PANEL_DIVIDER = "#e2e8ee"
